var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavImports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 16v480a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V373.736a16 16 0 0 1 32 0V480h448V32H32v106.264a16 16 0 0 1-32 0V16A16 16 0 0 1 16 0h480a16 16 0 0 1 16 16zM0 256a16 16 0 0 0 16 16h328.7l-82.112 82.114a16 16 0 1 0 22.627 22.627l109.427-109.428a16 16 0 0 0 0-22.626L285.216 135.259a16 16 0 0 0-22.627 22.627L344.7 240H16a16 16 0 0 0-16 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavImports);
export default __webpack_public_path__ + "static/media/nav-imports.bf5b665d0e6e019eb4eda13d05062ad1.svg";
export { ForwardRef as ReactComponent };